//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { useDeploymentStore } from "../../util/storage/DeploymentStore";
import { isArangoPlatformEnabledForDeployment } from "./databaseUiUrl";
import { useArangoPlatformFeature } from "./useArangoPlatformFeature";

export const useArangoPlatform = () => {
  const { deployment } = useDeploymentStore();
  const { isArangoPlatformFeatureEnabled } = useArangoPlatformFeature();

  return {
    isArangoPlatformEnabled: isArangoPlatformEnabledForDeployment(deployment, isArangoPlatformFeatureEnabled),
  };
};
